import { BlockProps } from "../types";
import { useBlock } from ".";

export interface UseOrdersBlockArgs extends BlockProps {}

export const useOrdersBlock = (args: UseOrdersBlockArgs) => {
  const block = useBlock({ ...args, type: "orders.orders", select: (enduser) => enduser });

  const enduser = block.enduserQuery.data;

  return {
    ...block,
    enduser,
  };
};
